$(document).ready(function(){
	$('.c-countdown').each(function() {
		let eventObject = {},
			dateStamp = $(this).data('time');
			eventObject.event = new Date(dateStamp).getTime(),
			that = $(this);

		let countdown = setInterval(function() {

			eventObject.now = new Date().getTime();

			if (eventObject.now <= eventObject.event) {

				let timeTillEvent = eventObject.event - eventObject.now,
					hours = String('00' + Math.floor(timeTillEvent % 864e5 / 36e5)).slice(-2),
					minutes = String('00' + Math.floor(timeTillEvent % 36e5 / 6e4)).slice(-2),
					seconds = String('00' + Math.floor(timeTillEvent % 6e4 / 1e3)).slice(-2),
					days = String(Math.floor(timeTillEvent / 864e5))

				if(days.length <= 2) {
					days = String('00' + days).slice(-2)
				}

				that.find('[data-type="days"]').html(days);
				that.find('[data-type="hours"]').html(hours);
				that.find('[data-type="minutes"]').html(minutes);
				that.find('[data-type="seconds"]').html(seconds);

			} else {
				that.hide();
				$('.js-countdown-ended').hide();
			}

		}, 1000)
	})

})
